import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcHomeIcon, IcMarketspaceFillIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';

import { Space } from 'STORE/Spaces/Space';

import { SidebarMenuItem } from '../SidebarMenuItem/SidebarMenuItem';
import { useSpacePanelPresenter } from './SpacePanel.presenter';
import styles from './SpacePanel.styles.m.css';
import { SpacePanelActionsButton } from './SpacePanelActionsButton/SpacePanelActionsButton';
import { SpacePanelGroups } from './SpacePanelGroups/SpacePanelGroups';
import { SpacePanelHeader } from './SpacePanelHeader/SpacePanelHeader';

interface ISpacePanelProps {
  space: Space | null;
}

export const SpacePanel: FC<ISpacePanelProps> = observer(({ space }) => {
  const presenter = useSpacePanelPresenter(space);
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <SpacePanelHeader space={space} />

      <SidebarMenuItem
        title={t('space_main')}
        link={presenter.spaceRoute}
        Icon={IcHomeIcon}
      />

      {presenter.isShowMarketsRoute && (
        <SidebarMenuItem
          title={t('space_market_tab')}
          link={presenter.marketsRoute}
          Icon={IcMarketspaceFillIcon}
        />
      )}

      {presenter.isShowPrimaryMarketRoute && (
        <SidebarMenuItem
          title={t('space_market_tab')}
          link={presenter.marketRoute}
          Icon={IcMarketspaceFillIcon}
        />
      )}

      <div className={styles.divider} />

      {space && <SpacePanelGroups space={space} />}

      {space && <SpacePanelActionsButton space={space} />}
    </div>
  );
});
